import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getSecret = () => localStorage.getItem("inerre_admin_secret") || "";
export const setSecret = (s) => localStorage.setItem("inerre_admin_secret", s);
export const clearSecret = () => localStorage.removeItem("inerre_admin_secret");
export const adminHeaders = () => ({ "X-Admin-Secret": getSecret() });

export const fileUrl = (path) => (path ? `${API}/files/${path}` : null);

export const roomUrl = (roomId) => `${window.location.origin}/r/${roomId}`;

export const api = axios.create({ baseURL: API });
